import { Fragment, useEffect, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, PopoverGroup, Menu, Transition, TabGroup, TabList, Tab, TabPanel, TabPanels, Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { AdjustmentsHorizontalIcon, Bars3Icon, MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import ShoppingCart from '../main_compos/ShoppingCart';
import { blackTextLogo } from '../../assets/images/logos';
import LanguageSelector from '../../utils/LanguageSelector';
import { useTranslation } from 'react-i18next';
import { ArrowLeftStartOnRectangleIcon, ChevronDownIcon, Cog8ToothIcon, UserCircleIcon } from '@heroicons/react/24/solid';
import Notify from '../../utils/useNotify';
import axios from 'axios';
import useConfirmation from '../../utils/useConfirmation';
import { useNavigate } from 'react-router';
import i18next from 'i18next';
import { truncateString } from '../../utils/truncateString';
import { fileNotFound, whatsappIcon } from '../../assets/images/icons';

export default function Navigation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openM, setOpenM] = useState(false);
  const [categories, setCategories] = useState([]);
  const [megaMenu, setMegaMenu] = useState([]);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;
  const username = localStorage.getItem('username');
  const token = localStorage.getItem('token');
  const { open, ConfirmComponent } = useConfirmation();

  const fetchCategories = async () => {
    try {
      const resC = await axios.get(`${localhost}all-categories`);
      const data = resC.data;
      setCategories(data);
    } catch (err) {
      // console.error(err);
    }
  };

  const fetchMegaMenu = async () => {
    try {
      const resProd = await axios.get(`${localhost}mega-menu`);
      const data = resProd.data;
      const updatedData = data.map(item => {
        const imgs = item.imgs ? JSON.parse(item.imgs) : null;
        return { ...item, imgs };
      });
      setMegaMenu(updatedData);
    } catch (err) {
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchUser = async () => {
    if (token) {
      try {
        const resUser = await axios.get(`${localhost}user`, { headers: { 'Authorization': `Bearer ${token}` } });
        setRole(resUser.data.role);
      } catch (err) {
        navigate("/signin");
        localStorage.removeItem("session_id");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchMegaMenu();
    if (token) {
      fetchUser();
    }
  }, []);

  const navLinks = [
    { name: 'shop', href: '/shop' },
    { name: 'about', href: '/about' },
  ];

  const menuItems = [
    role === "admin"
      ? [
        { label: 'dashboard', icon: AdjustmentsHorizontalIcon, href: '/admin' },
        { label: 'account', icon: UserCircleIcon, href: '/admin/settings' }
      ]
      : role === "customer"
        ? [
          { label: 'account', icon: UserCircleIcon, href: '/account/account-details' },
          { label: 'settings', icon: Cog8ToothIcon, href: '/account/dashboard' }
        ]
        : []
  ].flat();


  const handleLogout = async () => {
    try {
      await axios.post(localhost + 'logout', null, { headers: { 'Authorization': `Bearer ${token}` } });
      Notify("success", t("logout-msg"));
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        navigate("/signin");
      }, 500);
    } catch (err) {
      Notify("success", t("logout-msg"));
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        navigate("/signin");
      }, 500);
    }
  };

  const handleAction = () => {
    open(
      {
        title: t("logout-confirmation-header"),
        text: t("logout-confirmation-body"),
        action: "add",
      },
      handleLogout
    );
  };

  return (
    <div className="bg-white z-20">
      {ConfirmComponent}
      {/* Mobile menu */}
      <Dialog open={openM} onClose={setOpenM} className="relative z-10 lg:hidden">
        <DialogBackdrop transition className="fixed inset-0 bg-black/25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0" />

        <div className="fixed inset-0 z-10 flex">
          <DialogPanel transition className="relative flex w-full max-w-xs transform flex-col overflow-y-auto bg-white pb-12 shadow-xl transition duration-300 ease-in-out data-[closed]:-translate-x-full">
            <div className="flex px-4 pb-4 pt-5">
              <button type="button" onClick={() => setOpenM(false)} className="relative -m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <TabGroup className="mt-2">
              <TabPanels as={Fragment}>
                <TabPanel className="space-y-10 px-4 pt-10 pb-8">
                  <div className="grid grid-cols-2 gap-4">
                    {megaMenu.map((item, index) => (
                      <a href={`/product/${item.slug}`} key={index} className="group relative text-sm">
                        <img loading="lazy"  alt={item.name["en"]} src={!item.imgs ? fileNotFound : localimg + item.imgs[0]} className="aspect-square w-full rounded-lg bg-gray-100 object-cover group-hover:opacity-75" />
                        <p className="mt-0.5 text-xs sm:text-sm block font-medium text-gray-900 truncate">
                          {truncateString(item.name[i18next.language], 20)}
                        </p>
                      </a>
                    ))}
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">
                      {t("categories")}
                    </p>
                    <ul role="list" className="mt-6 flex flex-col space-y-6">
                      <li className="flow-root">
                        <a href={`/shop`} className="-m-2 block p-2 text-gray-500">
                          {t("all-categories")}
                        </a>
                      </li>
                      {categories.map((item, index) => (
                        <li key={index} className="flow-root">
                          <a href={`/shop?category=${item.id}`} className="-m-2 block p-2 text-gray-500">
                            {item.name[i18next.language]}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </TabPanel>
              </TabPanels>
            </TabGroup>
            <div className="space-y-6 border-t border-gray-200 px-4 py-6">
              {navLinks.map((page, index) => (
                <div key={index} className="flow-root">
                  <a href={page.href} className="-m-2 block p-2 font-medium text-gray-900">
                    {t(page.name)}
                  </a>
                </div>
              ))}
            </div>
            {token ? (
              <div className="border-t border-gray-200 px-2 py-2">
                <Menu as="div" className="relative z-30">
                  <Menu.Button className="capitalize flex w-full items-center gap-2 p-2 font-medium text-gray-900 hover:bg-gray-50">
                    {username}
                    <ChevronDownIcon className="h-4 w-4" />
                  </Menu.Button>
                  <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                  >
                    <Menu.Items className="absolute left-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5">
                      {menuItems.map((item) => (
                        <Menu.Item key={item.label} as="div">
                          {({ active }) => (
                            <a href={item.href} className={`flex items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                              <item.icon className="mr-3 h-5 w-5" />
                              {t(item.label)}
                            </a>
                          )}
                        </Menu.Item>
                      ))}

                      <Menu.Item as="div">
                        {({ active }) => (
                          <button onClick={handleAction} className={`flex w-full items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                            <ArrowLeftStartOnRectangleIcon className="mr-3 h-5 w-5" />
                            {t("logout")}
                          </button>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>

              </div>
            ) : (
              <div className="space-y-6 border-t border-gray-200 px-4 py-2">
                <a href="/signin" className="block p-2 font-medium text-gray-900 hover:bg-gray-50">
                  {t("signin")}
                </a>
                <a href="/signup" className="block p-2 font-medium text-gray-900 hover:bg-gray-50">
                  {t("signup")}
                </a>
              </div>
            )}
            <LanguageSelector screen="mobile" />
          </DialogPanel>
        </div>
      </Dialog>

      <header className="relative bg-white">
        <p className="flex h-9 uppercase items-center justify-center bg-black px-4 text-center text-xs sm:text-sm font-medium text-white sm:px-6 lg:px-8">{t("get-free-delivery", { price: "1000 MAD" })}</p>

        <nav aria-label="Top" className="mx-auto container px-4 sm:px-6 lg:px-8">
          <div className="border-b border-gray-200">
            <div className="flex h-16 items-center">
              <button type="button" onClick={() => setOpenM(true)} className="relative rounded-md bg-white p-2 text-gray-400 lg:hidden">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open menu</span>
                <Bars3Icon aria-hidden="true" className="size-6" />
              </button>

              {/* Logo */}
              <div className="ml-4 flex lg:ml-0">
                <a href="/">
                  <img loading="lazy"  src={blackTextLogo} className="h-7 w-auto" alt="logo" />
                </a>
              </div>

              {/* Flyout menus */}
              <PopoverGroup className="hidden lg:ml-8 lg:block lg:self-stretch">
                <div className="flex h-full space-x-8">
                  <Popover className="flex">
                    <div className="relative flex">
                      <PopoverButton className="relative z-10 -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-medium text-gray-700 transition-colors duration-200 ease-out hover:text-gray-800 data-[open]:border-orange-600 data-[open]:text-orange-600 focus:outline-none">
                        {t("our-products")}
                      </PopoverButton>
                    </div>
                    <PopoverPanel transition className="absolute inset-x-0 top-full text-sm text-gray-500 transition data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in">
                      <div aria-hidden="true" className="absolute inset-0 top-1/2 bg-white shadow" />
                      <div className="relative bg-white z-20">
                        <div className="mx-auto container px-8">
                          {
                            loading ? (
                              <div className="min-h-[45vh] flex items-center justify-center">
                                <div className="loading-spinner" />
                              </div>
                            ) : (
                              <div className="grid grid-cols-4 gap-x-8 gap-y-10 py-8">
                                <div className="col-start-2 col-span-3 grid grid-cols-3 gap-x-8">
                                  {megaMenu.map((item, index) => (
                                    <a href={`/product/${item.slug}`} key={index} className="group relative text-base sm:text-sm">
                                      <img loading="lazy"  alt={item.name['en']} src={!item.imgs ? fileNotFound : localimg + item.imgs[0]} className="aspect-square w-full rounded-lg bg-gray-100 object-cover group-hover:opacity-75" />
                                      <a href={`/product/${item.slug}`} className="mt-2 block font-medium text-gray-900 truncate">
                                        <span aria-hidden="true" className="absolute inset-0 z-10" />
                                        {item.name[i18next.language]}
                                      </a>
                                      <p aria-hidden="true" className="mt-1">
                                        {t("shop-now")}
                                      </p>
                                    </a>
                                  ))}
                                </div>
                                <div className="row-start-1 text-sm">
                                  <div>
                                    <p className="font-medium text-gray-900">
                                      {t("categories")}
                                    </p>
                                    <ul role="list" className="mt-6 space-y-6 sm:mt-4 sm:space-y-4">
                                      <li className="flow-root">
                                        <a href={`/shop`} className="hover:text-gray-800">
                                          {t("all-categories")}
                                        </a>
                                      </li>
                                      {categories.map((item, index) => (
                                        <li key={index} className="flex">
                                          <a href={`/shop?category=${item.id}`} className="hover:text-gray-800">
                                            {item.name[i18next.language]}
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </PopoverPanel>
                  </Popover>
                  {navLinks.map((page, index) => (
                    <a key={index} href={page.href} className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800">
                      {t(page.name)}
                    </a>
                  ))}
                </div>
              </PopoverGroup>

              <div className="ml-auto flex items-center">
                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6">
                  {token ? (
                    <>
                      <Menu as="div" className="relative z-30">
                        <Menu.Button className="capitalize flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-800">
                          {username}
                          <ChevronDownIcon className="h-4 w-4" />
                        </Menu.Button>
                        <Transition
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                        >
                          <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5">
                            {menuItems.map((item) => (
                              <Menu.Item key={item.label} as="div">
                                {({ active }) => (
                                  <a href={item.href} className={`flex items-center px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                                    <item.icon className="mr-3 h-5 w-5" />
                                    {t(item.label)}
                                  </a>
                                )}
                              </Menu.Item>
                            ))}

                            <Menu.Item as="div">
                              {({ active }) => (
                                <button onClick={handleAction} className={`flex items-center w-full px-4 py-2 text-sm ${active ? 'bg-gray-100' : ''}`} >
                                  <ArrowLeftStartOnRectangleIcon className="mr-3 h-5 w-5" />
                                  {t("logout")}
                                </button>
                              )}
                            </Menu.Item>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      <span aria-hidden="true" className="h-6 w-px bg-gray-200" />
                    </>
                  ) : (
                    <>
                      <a href="/signin" className="text-sm font-medium text-gray-700 hover:text-gray-800">
                        {t("signin")}
                      </a>
                      <span aria-hidden="true" className="h-6 w-px bg-gray-200" />
                      <a href="/signup" className="text-sm font-medium text-gray-700 hover:text-gray-800">
                        {t("signup")}
                      </a>
                    </>
                  )}
                </div>
                <LanguageSelector screen="desktop" />

                {/* Search */}
                <div className="flex lg:ml-6">
                  <a href="/search" className="p-2 text-black hover:text-black/80 rounded-full transition-colors duration-200 hover:bg-gray-100 active:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-200 focus:ring-offset-2">
                    <MagnifyingGlassIcon aria-hidden="true" className="size-6" />
                  </a>
                </div>

                {/* Cart */}
                <div className="ml-1 flow-root lg:ml-1">
                  <ShoppingCart />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <button className="z-30 fixed bottom-6 right-6 p-0 rounded-full focus:outline-none">
        <a href="https://wa.me/905359245987" target="_blank" rel="noopener noreferrer">
          <img loading="lazy"  src={whatsappIcon} alt="whatsapp" className='size-12' />
        </a>
      </button>
    </div>
  )
}
